import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import settingsContext, { IOptionType } from "contexts/SettingsContext";
import { randomString } from "utils/randomString";
import AddressBookAttachment from "../AddressBookAttachment";

const AttachmentsModal: FC<Props> = ({
  toggle,
  pack,
  onPreview,
  onDownload,
}) => {
  const { t } = useTranslation();

  const [, setAttachmentsLocation] = useState<string>("center");

  const { options } = useContext(settingsContext);

  useEffect(() => {
    if (options) {
      const attL = options.find(
        (x) => x.Type === IOptionType.caseAttachAttachmentsLocation,
      );

      if (attL) {
        setAttachmentsLocation(attL.Value);
      }
    }
  }, [options]);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.title}>
            {t("documents.attachments")}
            <CloseIcon
              className={styles.closeIcon}
              onClick={(e) => {
                toggle(false);
                e.stopPropagation();
              }}
            />
          </div>
          <div className={styles.list}>
            {pack.Attachments.map((attach) => (
              <AddressBookAttachment
                className={styles.attachment}
                key={attach.Id + randomString()}
                onDownload={(attach) => {
                  onDownload?.(pack, attach);
                }}
                onPreview={(attach) => {
                  if (onPreview) {
                    onPreview(pack, attach);
                    toggle(false);
                    return;
                  }
                }}
                attachment={attach}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AttachmentsModal;
